import { CalendarIcon } from '@heroicons/react/24/solid'

interface Props {
  date: string
  className?: string
}

const Date = ({ date, className = '' }: Props) => (
  <span className={`${className} flex items-center text-xs `}>
    <CalendarIcon className='mr-2 mb-1' width={12} />
    {date}
  </span>
)

export default Date
